import { memo, useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { BzModal, BzModalHeader,  BzModalBody, BzButton, BzModalFooter} from '../../../components';
import { useDispatch, useSelector } from 'react-redux';
import { handleModal, handleModalData } from '../../../redux/actions/modals';
import { APP_INFO_PARAMS, ORDER_PRODUCT_TYPES, ORDER_TYPES, WATCHLIST_GRID_INDEX } from '../../../utils/global_variables';
import { saveCartForGoback, storeGridData, updateOrderCartRowData } from '../../../redux/actions/orderCart';
import { getAppInfoData } from '../../../utils/global_functions';
import { toastConfig } from '../../../redux/actions/toast';

const SaveCartCnfrmModal = ({ setOrderEntryTab, setActiveTabKey }) => {

    const dispatch = useDispatch();
    const modals = useSelector(state => state?.modals?.modals);
    const arrGridData = useSelector(state => state.orderCart.arrOrderEntryGridData);
    const objSelectedCartRowData = useSelector(state => state?.orderCart?.objSelectedCartRowData);   //srikanth
    const objSavedCartDetails = useSelector(state => state?.orderCart?.objCartForGoBack);
    //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 08-04-2024 - Start
    const appInfo = useSelector(state => state.appInfo.appInfo);
    const holdingsScrips = useSelector(state => state?.holdings?.holdingsScrips);
    const nOrderCartCount = getAppInfoData(APP_INFO_PARAMS?.APP_ORDERCART_ORDER_COUNT, appInfo);
    // BT-106965 : OrderCart: SAT2 : ManasaB : 17-05-2024 - Start
    const [strCartName, setStrCartName] = useState('');
    const [bisGoBack, setBIsGoBack] = useState(false);
    const [strMethod, setStrMethod] = useState('create');
    useEffect(() => {
        if (Object.keys(objSavedCartDetails)?.length > 0) {
            setStrCartName(objSavedCartDetails?.cartName);
            setBIsGoBack(true);
        }
        //BT-106965 : Ordercart : SAT2 Issues : ManasaB : 03-06-2024 : Start
        else {
            setStrCartName('');
            setBIsGoBack(false);
        }
        if (Object.keys(objSelectedCartRowData)?.length > 0 || Object.keys(objSavedCartDetails)?.length > 0) {
            setStrMethod('edit');
        }
        else {
            setStrMethod('create');
        }
        //BT-106965 : Ordercart : SAT2 Issues : ManasaB : 03-06-2024 : End
    }, [objSavedCartDetails, objSelectedCartRowData]);
    // BT-106965 : OrderCart: SAT2 : ManasaB : 17-05-2024 - End
    const onHandleClose = () => {
        dispatch(storeGridData([]));
        setBIsGoBack(false);
        dispatch(saveCartForGoback({}));
        dispatch(updateOrderCartRowData({}));//BT-106965 : Ordercart : Security Measures Warning : ManasaB : 24-04-2024 
        // BT-106965 : OrderCart: SAT2 : ManasaB : 17-05-2024 - Start 
        dispatch(handleModal([{ 'SAVE_CART_CONFIRM_MODAL': false }, { 'ORDER_ENTRY_MODAL': true }, true]));
        dispatch(handleModalData({ data: { orderEntryTab: ORDER_TYPES.MULTI_SCRIP } }));
        setOrderEntryTab(ORDER_TYPES.MULTI_SCRIP);
        setActiveTabKey(ORDER_TYPES.BASKET);
        // BT-106965 : OrderCart: SAT2 : ManasaB : 17-05-2024 - End
    };

    const handleClick = () => {
        dispatch(storeGridData([]));
        //BT-106965 : Ordercart : SAT2 Issues : ManasaB : 03-06-2024 : Start
        setBIsGoBack(false);
        setStrMethod('create');
        //BT-106965 : Ordercart : SAT2 Issues : ManasaB : 03-06-2024 : End
        dispatch(saveCartForGoback({}));
        dispatch(updateOrderCartRowData({}));//BT-106965 : Ordercart : Security Measures Warning : ManasaB : 24-04-2024 
        dispatch(handleModal([{ 'ORDER_ENTRY_MODAL': false }, true]));
        dispatch(handleModal([{ 'SAVE_CART_CONFIRM_MODAL': false }, true]));

    };
    const handleSave = () => {
        if (arrGridData.length <= nOrderCartCount) {
            //BT-106965 : Ordercart : SAT2 Issues : ManasaB : 17-05-2024 : To restrict scrip which price is not multiple of price tick - Start
            let bPriceValidation = false;
            let strPrice = '';
            arrGridData?.forEach(eachData => {
                let scripPrice = '';
                let nScripPrice = '';
                let nTriggerPrice = '';

                if (eachData["ORDER TYPE"] === 'RL') {
                    if (eachData["PRICE"] > 0)
                        scripPrice = eachData["PRICE"];
                }
                else if (eachData["ORDER TYPE"] === 'SL-MKT') {
                    if (eachData["SL TRIGGER"] > 0)
                        nTriggerPrice = eachData["SL TRIGGER"];
                }
                else if (eachData["ORDER TYPE"] === 'SL') {
                    if (eachData["SL LIMIT"] > 0) {
                        scripPrice = eachData["SL LIMIT"];
                    }
                    if (eachData["SL TRIGGER"] > 0) {
                        nTriggerPrice = eachData["SL TRIGGER"];
                    }
                }
                let DecimalLocator = eachData["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR];
                const nSelPriceTick = eachData["SYMBOL"][WATCHLIST_GRID_INDEX.PRICE_TICK] * eachData["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR];
                if (scripPrice > 0) {
                    nScripPrice = scripPrice;
                    strPrice = 'price';
                    const PriceinPaise = parseInt(Math.round(parseFloat((nScripPrice * DecimalLocator).toString())).toString());
                    const PriceTickInRs = (parseFloat(nSelPriceTick) / DecimalLocator).toFixed(eachData["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]);
                    if (PriceinPaise % parseInt(nSelPriceTick) !== 0) {
                        bPriceValidation = true;
                        dispatch(toastConfig({ autoDismiss: true, show: true, message: `The entered ${strPrice} value is not in multiple of price tick which is ${PriceTickInRs} ` }));
                        return false;
                    }
                }
                if (nTriggerPrice > 0) {
                    nScripPrice = nTriggerPrice;
                    strPrice = 'trigger price';
                    const PriceinPaise = parseInt(Math.round(parseFloat((nScripPrice * DecimalLocator).toString())).toString());
                    const PriceTickInRs = (parseFloat(nSelPriceTick) / DecimalLocator).toFixed(eachData["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]);
                    if (PriceinPaise % parseInt(nSelPriceTick) !== 0) {
                        bPriceValidation = true;
                        dispatch(toastConfig({ autoDismiss: true, show: true, message: `The entered ${strPrice} value is not in multiple of price tick which is ${PriceTickInRs}` }));
                        return false;
                    }
                }
            });
            if (bPriceValidation) {
                //  dispatch(toastConfig({ autoDismiss: true, show: true, message: `The entered ${strPrice} value is not in multiple of price tick which is  `}));
                return false;
            }
            //BT-106965 : Ordercart : SAT2 Issues : ManasaB : 17-05-2024 : To restrict scrip which price is not multiple of price tick - End
            else {
                let bIsValidationFailed = false;
                arrGridData.forEach(eachHoldingScrip => {
                    if (eachHoldingScrip["PROD TYPE"].includes(ORDER_PRODUCT_TYPES.DELIVERY) && eachHoldingScrip["BUY/SELL"] === "SELL") { //BREEZE : 305 : Side tray Order Cart : ManasaB : 20-12-2024 : Taken product types from backend
                        const objHoldingScrip = holdingsScrips.find(eachScrip => eachScrip.nToken === eachHoldingScrip["SYMBOL"][WATCHLIST_GRID_INDEX.TOKEN]);
                        if (objHoldingScrip && Object.keys(objHoldingScrip).length > 0) {
                            if (eachHoldingScrip["QTY"] > parseInt(objHoldingScrip.TOTALFREEQUANTITY)) {
                                bIsValidationFailed = true;
                                dispatch(toastConfig({ autoDismiss: true, show: true, message: `Entered Qty is greater than Qty available in holdings for ${eachHoldingScrip["SYMBOL"][WATCHLIST_GRID_INDEX.SYMBOL]}.Short selling is not allowed for Delivery ` }));
                            }
                        }
                        else {
                            bIsValidationFailed = true;
                            dispatch(toastConfig({ autoDismiss: true, show: true, message: `Entered Qty is greater than Qty available in holdings for ${eachHoldingScrip["SYMBOL"][WATCHLIST_GRID_INDEX.SYMBOL]}.Short selling is not allowed for Delivery ` }));
                        }
                    }
                });
                if (bIsValidationFailed) {
                    // dispatch(toastConfig({ autoDismiss: true, show: true, message: `Entered Qty is greater than Qty available in holdings for ${eachHoldingScrip["SYMBOL"][WATCHLIST_GRID_INDEX.SYMBOL]}.Short selling is not allowed for Delivery ` }));
                }
                else {
                    var arrOrderData = [];
                    if (arrGridData?.length !== 0) {
                        arrGridData?.forEach((ele, i) => {
                            let objData = {
                                id: i + 1,
                                buySellType: ele["BUY/SELL"],
                                productType: ele["PROD TYPE"].toUpperCase(),
                                orderType: ele["ORDER TYPE"],
                                validity: ele["VALIDITY"],
                                exchange: ele["SYMBOL"][WATCHLIST_GRID_INDEX.EXCHANGE],
                                count: ele["QTY"],
                                amo: ele["AMO"],
                                slTrigger: ele["SL TRIGGER"],
                                slLimit: ele["SL LIMIT"],
                                price: ele["PRICE"],
                                exchangeId: ele["SYMBOL"][WATCHLIST_GRID_INDEX.SEGMENT_ID],
                                token: ele["SYMBOL"][WATCHLIST_GRID_INDEX.TOKEN],
                                decimalLocator: ele["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR],
                                decimalLocatorLength: ele["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH],
                                symbol: ele["SYMBOL"][WATCHLIST_GRID_INDEX.SYMBOL],
                                series: ele["SYMBOL"][WATCHLIST_GRID_INDEX.SERIES],
                                instrument: ele["SYMBOL"][WATCHLIST_GRID_INDEX.INSTRUMENT],
                                exchangeSegment: ele["SYMBOL"][WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT],
                                isinCode: ele["SYMBOL"][WATCHLIST_GRID_INDEX.ISIN_CODE],
                                securityDesc: ele["SYMBOL"][WATCHLIST_GRID_INDEX.SECURITY_DESCRIPTION],
                                priceTick: ele["SYMBOL"][WATCHLIST_GRID_INDEX.PRICE_TICK] * ele["SYMBOL"][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR],//BT-106965 : Ordercart : SAT2 Issues : ManasaB : 11-06-2024 : Start
                                mappedSegId: ele["SYMBOL"][WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID],
                                marketLot: ele["SYMBOL"][WATCHLIST_GRID_INDEX.REGULAR_LOT]
                            };
                            arrOrderData.push(objData);
                        });
                        dispatch(storeGridData(arrGridData));
                        dispatch(handleModal([{ 'ORDER_ENTRY_MODAL': false }, { 'SAVE_CART_CONFIRM_MODAL': false }, { 'ORDER_CART_NAME_MODAL': true }]), true);
                        dispatch(handleModalData({ data: { orderCartInfo: arrOrderData, orderEntryTab: 'multi_scrip', activeTabKey: 'basket', method: strMethod, ordercartName: objSelectedCartRowData?.ordercartName ? objSelectedCartRowData?.ordercartName : strCartName, strOrderCartId: objSelectedCartRowData?.ordercartId, isGoback: bisGoBack } }));
                        // dispatch(handleModalData({ data: { orderCartInfo: arrOrderData, orderEntryTab: 'multi_scrip', activeTabKey: 'basket' } }));
                        setStrCartName('');
                        //BT-106965 : Ordercart : SAT2 Issues : ManasaB : 03-06-2024 : Start
                        setStrMethod('create');
                        setBIsGoBack(false);
                        //BT-106965 : Ordercart : SAT2 Issues : ManasaB : 03-06-2024 : End
                    }
                }
            }
        }
        else {
            dispatch((toastConfig({ autoDismiss: true, show: true, message: `You can not add more than ${nOrderCartCount} in single cart` })));
            dispatch(handleModal([{ 'SAVE_CART_CONFIRM_MODAL': false }, true]));//BT-106965 : Ordercart : SAT1 Issues : ManasaB : 16-04-2024  
        }
        //BT-106965 : Ordercart : SAT1 Issues : ManasaB : 08-04-2024 - End
    };
    return (
        <>
            <BzModal size='sm' show={modals['SAVE_CART_CONFIRM_MODAL']} onHide={onHandleClose}>
                <BzModalHeader className='modaltabs-header'>
                    <Container fluid className='p-0'>
                        <Row className='g-0'>
                            <Col md={11} className='d-flex justify-content-start align-items-center'>
                                <div className='font-medium font-size4 color-text'>Save Cart</div>
                            </Col>
                            <Col md={1} className='d-flex justify-content-end align-items-center'>
                                <div className='icon-16 icon-dark icon-close' onClick={onHandleClose}></div>
                            </Col>
                        </Row>
                    </Container>
                </BzModalHeader>
                <BzModalBody>
                    <Container fluid className='p-0'>
                        <Row className='g-0 mb-3'>
                            <Col className='d-flex justify-content-start'>
                                <div className='font-regular font-size4 color-text'>Cart not saved. Do you want to save the changes?</div>
                            </Col>
                        </Row>
                    </Container>
                </BzModalBody>
                <BzModalFooter>
                    <Container fluid className='p-0'>
                        <Row className='g-0'>
                            <Col className='d-flex justify-content-end'>
                                <BzButton className='btn btn-md btn-outline me-2' onClick={handleClick}>CANCEL</BzButton>
                                <BzButton className='btn btn-md btn-primary ms-2' onClick={handleSave}>SAVE CHANGES</BzButton>
                            </Col>
                            {/* <Col className='d-flex justify-content-end'>
                                <BzButton className='btn btn-md btn-primary' onClick={handleSave}>SAVE CHANGES</BzButton>
                            </Col> */}
                        </Row>
                    </Container>
                </BzModalFooter>
            </BzModal>

        </>
    );
};

export default memo(SaveCartCnfrmModal);
